import { createSvgIcon } from '@mui/material/utils'

const ReportSuccess = createSvgIcon(
  <>
    <path
      d="M23.5 46.5C35.9264 46.5 46 36.4264 46 24C46 11.5736 35.9264 1.5 23.5 1.5C11.0736 1.5 1 11.5736 1 24C1 36.4264 11.0736 46.5 23.5 46.5Z"
      stroke="#204ECF"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M23.5003 43.2826C34.1497 43.2826 42.7828 34.6496 42.7828 24.0002C42.7828 13.3507 34.1497 4.71765 23.5003 4.71765C12.8508 4.71765 4.21777 13.3507 4.21777 24.0002C4.21777 34.6496 12.8508 43.2826 23.5003 43.2826Z"
      stroke="#204ECF"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M13.7012 25.5864L19.7762 31.6502L34.8287 16.5864"
      stroke="#204ECF"
      strokeWidth="1.125"
      strokeMiterlimit="10"
    />
  </>,
  'ReportSuccess'
)

export default ReportSuccess
